var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyebrowOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.675,
    height: 12.63,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-408 15295)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 5,
    transform: "translate(408 -15295)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(412 -15284)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.659,2.736a2.713,2.713,0,0,0-.076-.279c-.016-.048-.034-.1-.053-.143-.005-.013,0-.012,0,0l-.016-.037-.034-.071c0-.006,0-.011-.005-.017-.136-.035-.253-.068-.367-.108-.992-.352-1.964-.772-2.975-1.055A32.585,32.585,0,0,0,18.913.052a9.785,9.785,0,0,0-4.889.991c-2.849,1.114-5.651,2.349-8.5,3.472A29.627,29.627,0,0,1,1.45,5.831,1.388,1.388,0,0,0,.256,6.908c-.606,1.98-.045,3.8.721,5.722.184-.156.307-.251.42-.357A49.008,49.008,0,0,1,13.021,3.809a13.686,13.686,0,0,1,7.793-1.725c1.956.23,3.907.493,5.861.737-.006-.029-.01-.057-.016-.085",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyebrowOff);
export default __webpack_public_path__ + "static/media/eyebrowOFF.f7a48985729dec3561ba831513dee673.svg";
export { ForwardRef as ReactComponent };